<template>
  <footer class="c-small-footer">
    <fh-logo
      :link="logo.link"
      :aria-label-link="logo.ariaLabelLink"/>
    <div v-if="!hideSocial"
      class="c-small-footer__social">
      <fh-social-icon
        v-for="(icon, index) in icons"
        :key="`${icon.iconName}-${index}`"
        :link="icon.link"
        :icon-name="icon.iconName"
        :aria-label-link="icon.ariaLabelLink"/>
    </div>
    <div class="c-small-footer__contact">
      <fh-contact-link
        v-for="(link, index) in contactLinks"
        :key="`${link.iconName}-${index}`"
        :link="link.link"
        :icon-name="link.iconName"
        :text="link.text"
        :aria-label-link="link.ariaLabelLink"/>
    </div>
  </footer>
</template>

<script>
import FHLogo from '@forlagshuset/v-logo'
import FHContactLink from '@forlagshuset/v-contact-link'
import FHSocialIcon from '@forlagshuset/v-social-icon'

export default {
  name: 'fh-small-footer',

  components: {
    'fh-logo': FHLogo,
    'fh-contact-link': FHContactLink,
    'fh-social-icon': FHSocialIcon
  },

  data() {
    return {
      logo: {
        link: 'https://www.fagbokforlaget.no/',
        ariaLabelLink: 'Link fo Fagbokforlaget main page'
      },
      icons: [
        {
          link: 'https://magasin.fagbokforlaget.no/fagbokforlaget-paa-facebook',
          ariaLabelLink: 'Link to Fagbokforlaget Facebook page',
          iconName: 'Facebook'
        },
        {
          link: 'https://twitter.com/Fagbokforlaget',
          ariaLabelLink: 'Link to Fagbokforlaget Twitter page',
          iconName: 'Twitter'
        },
        {
          link: 'https://www.linkedin.com/company/fagbokforlaget-v&b-as',
          ariaLabelLink: 'Link to Fagbokforlaget LinkedIn page',
          iconName: 'LinkedIn'
        },
        {
          link: 'https://issuu.com/fagbokforlaget',
          ariaLabelLink: 'Link to Fagbokforlaget Issuu page',
          iconName: 'Issuu'
        }
      ],
      contactLinks: [
        {
          link: 'https://www.fagbokforlaget.no/Kontakt/Personvern',
          ariaLabelLink: 'Link to Fagbokforlaget privacy page',
          iconName: 'Padlock',
          text: 'Personvern'
        },
        {
          link: 'https://www.fagbokforlaget.no/kontakt',
          ariaLabelLink: 'Link to Fagbokforlaget contact page',
          iconName: 'Cloud',
          text: 'Kontakt oss'
        }
      ]
    }
  },

  props: {
    hideSocial: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.c-small-footer {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  background-color: #2e2d84;
  min-height: 6.5em;
  flex-direction: row;
  align-items: center;
  flex-direction: column;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;

  *:focus {
    outline: 2px dashed #fff;
  }

  @media (min-width: 768px) {
    flex-direction: row;
  }
}

.c-small-footer__social,
.c-small-footer__contact {
  display: inline-flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  padding: 1.5em 0;

  a {
    margin: .5em;
  }
}

.c-small-footer__contact {
  flex-direction: column;

  @media (min-width: 400px) {
    flex-direction: row;
  }
}
</style>
